<script lang="ts">
	import type { SbMuxVideo } from '$lib/storyblok/types';
	import PageGrid16 from '$lib/storyblok/components/pageGrid16.svelte';
	import type { ImageBlock } from '../imageBlock.svelte';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '$lib/storyblok/editable';
	import Blok from '$lib/storyblok/blok.svelte';

	interface Props {
		content: ISbStoryData<{
			headline: string;
			assets: Array<ISbStoryData<ImageBlock | SbMuxVideo>['content']>;
		}>['content'];
	}

	let { content }: Props = $props();
</script>

<section use:editable={content} class="bg-dark-grey px-1 pb-1 pt-16 lg:pt-32">
	<PageGrid16 margin>
		<h1
			class="col-span-full mb-8 text-[36px]/[112%] tracking-[-.36px] text-white lg:col-start-2 lg:col-end-[16] lg:mb-16 lg:text-[64px]/[110%] lg:tracking-[-.64px]"
		>
			{content.headline}
		</h1>
	</PageGrid16>

	<div class="flex gap-1 max-lg:flex-col">
		{#if content.assets.length > 0}
			<div class="aspect-square overflow-hidden rounded-[4px] lg:aspect-[4/1] lg:flex-1">
				<Blok content={content.assets[0]} />
			</div>
		{/if}
		{#if content.assets.length > 1}
			<div class="flex flex-col gap-1 lg:flex-1">
				<div
					class="aspect-square overflow-hidden rounded-[4px] lg:aspect-2/1"
					class:lg:aspect-[0.75]={content.assets.length < 3}
				>
					<Blok content={content.assets[1]} />
				</div>
				{#if content.assets.length > 2}
					<div class="aspect-square overflow-hidden rounded-lg lg:aspect-2/1">
						<Blok content={content.assets[2]} />
					</div>
				{/if}
			</div>
		{/if}
	</div>
</section>
